import { dataHierarchy } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHierarchy = /*#__PURE__*/createIcon(dataHierarchy)
export default IconHierarchy
